var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea__input",class:{
	focus: _vm.isFocused,
},style:({
	height: _vm.height
})},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],ref:"textarea",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.value)},on:{"focus":function($event){_vm.isFocused = true},"blur":function($event){_vm.isFocused = false},"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var staticRenderFns = []

export { render, staticRenderFns }